module.exports = __webpack_public_path__ + "images/emoji/ribbon.538744f8a5ec27c10e96.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ribbon.png
// module id = hW43
// module chunks = 13